module.exports = __webpack_public_path__ + "static/media/Religare.a39e35da.png";